import React from 'react';
import {
  Facebook,
  Instagram,
  Twitter,
  Linkedin,
  Youtube,
  Globe,
  ExternalLink,
  Music2,
} from 'lucide-react';

const TikTokIcon = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);

const VendorSocialMedia = ({ socialMedia }) => {
  if (
    !socialMedia ||
    typeof socialMedia !== 'object' ||
    Object.keys(socialMedia).length === 0
  ) {
    return null;
  }

  const socialMediaIcons = {
    facebook: Facebook,
    instagram: Instagram,
    twitter: Twitter,
    linkedin: Linkedin,
    youtube: Youtube,
    tiktok: TikTokIcon,
    snapchat: Music2,
    pinterest: ExternalLink,
    website: Globe,
  };

  const getPlatformName = (platform) => {
    const platformNames = {
      tiktok: 'TikTok',
      snapchat: 'Snapchat',
      pinterest: 'Pinterest',
    };
    return (
      platformNames[platform.toLowerCase()] ||
      platform.charAt(0).toUpperCase() + platform.slice(1)
    );
  };

  const getIcon = (platform) => {
    const normalizedPlatform = platform.toLowerCase();
    return socialMediaIcons[normalizedPlatform] || ExternalLink;
  };

  const socialMediaEntries = Object.entries(socialMedia).filter(
    ([, url]) => url && url.trim()
  );

  if (socialMediaEntries.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap items-center gap-2">
      {socialMediaEntries.map(([platform, url]) => {
        const Icon = getIcon(platform);
        const platformName = getPlatformName(platform);

        return (
          <a
            key={platform}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-1.5 rounded-full border border-m-border-light bg-m-surface px-3 py-1.5 transition-colors hover:border-m-ink hover:bg-m-ink hover:text-white"
            aria-label={`Visit ${platformName}`}
          >
            <Icon className="h-3.5 w-3.5 text-m-ink-muted transition-colors group-hover:text-white" />
            <span className="text-xs font-medium text-m-ink-muted transition-colors group-hover:text-white">
              {platformName}
            </span>
          </a>
        );
      })}
    </div>
  );
};

export default VendorSocialMedia;
